import React from "react";
import { motion } from "framer-motion";
import "./WhyChoose.css";
import verified from "../Images/Verified.png";
import secure from "../Images/Secure Payments.png";
import rentals from "../Images/Easy Rentals.png";

const WhyChoose = () => {
  const items = [
    { img: verified, title: "Verified Listings", text: "Every property is checked by our team." },
    { img: secure, title: "Secure Payments", text: "Safe transactions with encrypted gateway." },
    { img: rentals, title: "Easy Rentals", text: "24/7 support for smooth rental process." },
  ];

  return (
    <section className="why container">
      <h2 className="section-title">Why Choose Dhanushdhari?</h2>

      <div className="why-box">
        {items.map((it, i) => (
          <motion.div
            className="why-item"
            key={i}
            initial={{ opacity: 0, scale: 0.98 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
          >
            <div className="icon-wrap"><img src={it.img} alt={it.title} className="why-icon" /></div>
            <h4>{it.title}</h4>
            <p>{it.text}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default WhyChoose;
